// Export types individually to avoid conflicts in parent index
export type {
  EInvoiceStatus,
  EInvoiceSubmissionUpdate,
  Invoice,
  Patient,
  User,
  ReportEInvoicesProps,
  EInvoiceBatchInvoiceCandidate,
  EInvoiceBatchFilters,
  EInvoiceBatchAnalytics,
  EInvoiceBatchInvoiceConnection,
  ConfirmationModalProps,
} from "./ReportEInvoices.types";

import { lazy } from "@loadable/component";
import { Suspense } from "react";
import { ErrorBoundary } from "@sentry/react";
import { ErrorFallback } from "../../patterns";
import { ReportEInvoicesProps } from "./ReportEInvoices.types";
import { ReportEInvoicesLoading } from "./ReportEInvoices.loading";

export const ReportEInvoicesLoadable = lazy(
  () => import("./ReportEInvoices")
);

export const ReportEInvoices = (props: ReportEInvoicesProps) => {
  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Suspense fallback={<ReportEInvoicesLoading />}>
        <ReportEInvoicesLoadable {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};

